function getEnvVar(key: string): string {
  const value = (import.meta as { env?: Record<string, string> }).env?.[key];
  if (!value) {
    throw new Error(`Missing environment variable: ${key}. Check your .env file.`);
  }
  return value;
}

export interface ClientEnv {
  BASE_DOMAIN: string;
  SENTRY_DSN: string | undefined;
  UMAMI_URL: string | undefined;
  UMAMI_WEBSITE_ID: string | undefined;
}

let _clientEnv: ClientEnv | null = null;

function loadClientEnv(): ClientEnv {
  return {
    BASE_DOMAIN: getEnvVar('VITE_BASE_DOMAIN'),
    SENTRY_DSN: (import.meta as { env?: Record<string, string> }).env?.VITE_SENTRY_DSN || undefined,
    UMAMI_URL: (import.meta as { env?: Record<string, string> }).env?.VITE_UMAMI_URL || undefined,
    UMAMI_WEBSITE_ID:
      (import.meta as { env?: Record<string, string> }).env?.VITE_UMAMI_WEBSITE_ID || undefined,
  };
}

export function getClientEnv(): ClientEnv {
  if (!_clientEnv) {
    _clientEnv = loadClientEnv();
  }
  return _clientEnv;
}

export const clientEnv = {
  get BASE_DOMAIN(): string {
    return getClientEnv().BASE_DOMAIN;
  },
  get SENTRY_DSN(): string | undefined {
    return getClientEnv().SENTRY_DSN;
  },
  get UMAMI_URL(): string | undefined {
    return getClientEnv().UMAMI_URL;
  },
  get UMAMI_WEBSITE_ID(): string | undefined {
    return getClientEnv().UMAMI_WEBSITE_ID;
  },
};
